if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
       
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
             // console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;         
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
         // custom_code
         document.getElementById('custom_line_property').innerHTML = '';
          const variantSelections = {};
         const legend_custom = variantSelects.querySelector('fieldset');
          let custom_input_obj = legend_custom.querySelector('input[type="radio"]:checked');
          var select_size_value = custom_input_obj.value;
          var custom_select_size_lower = select_size_value.toLowerCase();
        
     
       document.querySelectorAll('fieldset.product-form__input').forEach((fieldset) => {
        const legend = fieldset.querySelector('legend');
        const groupName = legend ? legend.textContent.trim() : 'Unknown';
      
        let selectedInput = fieldset.querySelector('input[type="radio"]:checked');
      
         let variant_name = selectedInput?.getAttribute('name')?.toLowerCase();//console.log("final_prateek_outer"+variant_name);
        // If checked input is disabled or doesn't exist, find first non-disabled
       if (variant_name && !variant_name.includes('size')) {   //console.log("inner_check_oave"+variant_name);
        if (!selectedInput || selectedInput.disabled) {
          selectedInput = fieldset.querySelector('input[type="radio"]:not(:disabled)');
          
          if (selectedInput) {
          //  selectedInput.checked = true; // Actively check it
            selectedInput.click();  
          }
        }
       } // name check
        variantSelections[groupName] = selectedInput ? selectedInput.value : null;
      });
       if ((custom_select_size_lower.includes("custom")) || (custom_select_size_lower.includes("matns")) ) { 

            const dimensionEl = document.querySelector('.variantopt_dimension');
              if (dimensionEl) {
                dimensionEl.classList.add('hide_custom_options');
              }
              
              const customOptionEl = document.querySelector('.custom_option_main_fordimension');
              if (customOptionEl) {
                customOptionEl.classList.remove('hide_custom_options');
              }
         
       } else {
             /* extra code  */ 
             document.getElementById("custom_variant_select").classList.remove("hide_custom_options");
            document.getElementById("custom_only_for_custom").classList.add("hide_custom_options");
         /* extra code  */ 
         const customOptionEl = document.querySelector('.custom_option_main_fordimension');
              if (customOptionEl) {
                customOptionEl.classList.add('hide_custom_options');
              }
         
             const dimensionEl = document.querySelector('.variantopt_dimension');
              if (dimensionEl) {
                dimensionEl.classList.remove('hide_custom_options');
              }   
         /*code for price update fontend mobile sticky*/
          setTimeout(function () {
         // Get the custom selling price and MRP from attributes
        var customSellingPrice = Number(document.querySelector('.custom_selling_price')?.getAttribute('variants_price'));
        var customMrpPrice = Number(document.querySelector('.custom_mrp_price')?.getAttribute('variants_compare_price'));        
        // Get the save amount text
        var savePerAmt = document.querySelector('.saveamount.for_pdf')?.textContent;        
        // Convert prices using your custom function
        var priceConvertSelling = convert_rupees(customSellingPrice);
        var priceConvertMrp = convert_rupees(customMrpPrice);        
        // Update the DOM with new prices
        document.querySelector('.custom_regular_price').innerHTML = priceConvertSelling;
        document.querySelector('.custom_compare_price').innerHTML = priceConvertMrp;
        document.querySelector('.custom_saveamount').innerHTML = savePerAmt;
    //console.log('price_update_c'+customSellingPrice);
          },1200);
        /* end */
       }
        
          // custom code
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          // 🔥 Our Fix
          queueMicrotask(() => {
            const customDropdown = document.getElementById('custom_only_for_custom');
            if (!customDropdown || !variant?.id) return;

            if (variant?.option1?.toLowerCase() === 'custom') {
                customDropdown.value = String(variant.id);
            }
          });

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));//console.log(variant);
               /**/
              var custom_variant_id = variant.id;
              document.querySelectorAll('.var_specification_meta').forEach(el => {
                  el.classList.add('hide_var_meta');
                });
             // console.log("checkout: "+custom_variant_id);
              if (variant?.option1 && variant.option1.toLowerCase() !== 'custom') {
                // updateInventory(variant.sku, this.dataset.section);

                /* code for variant additional fields */
                  var additional_line_item = "";
                var attr_custom_length = document.querySelector('#variant_block_custom_length');
                if (attr_custom_length && attr_custom_length.textContent.trim() !== "") {
                  additional_line_item += "<input type='hidden' name='properties[Length]' value='" + attr_custom_length.textContent.trim() + "'>";
                }
                var attr_custom_width = document.querySelector('#variant_block_custom_width');
                if (attr_custom_width && attr_custom_width.textContent.trim() !== "") {
                  additional_line_item += "<input type='hidden' name='properties[Width]' value='" + attr_custom_width.textContent.trim() + "'>";
                }
                var attr_custom_height = document.querySelector('#variant_block_custom_height');
                if (attr_custom_height && attr_custom_height.textContent.trim() !== "") {
                  additional_line_item += "<input type='hidden' name='properties[Height]' value='" + attr_custom_height.textContent.trim() + "'>";
                }
                document.getElementById('addition_line_property').innerHTML = additional_line_item;

              //  console.log(additional_line_item);

               /* code for variant additional fields */

                 /* ======================================================
                  API-BASED AVAILABILITY CHECK (FINAL)
                  Runs AFTER variant update to disable unavailable sizes.
                ======================================================= */
                // setTimeout(() => {
                //       const optionInputs = this.querySelectorAll("input[data-sku]");
                //       optionInputs.forEach(input => {
                //         const sku = input.dataset.sku;
                //         if (!sku) return;

                //         fetch("https://duroflex.binaryic.in/index.php/api/get-inventory-by-sku", {
                //           method: "POST",
                //           headers: { "Content-Type": "application/json" },
                //           body: JSON.stringify({ sku: sku })
                //         })
                //           .then(res => res.json())
                //           .then(data => {
                //             console.log("input value",input.value);
                //             console.log("data check input in  change",data?.inventory?.[0]?.available);
                //             const available = data?.inventory?.[0]?.available;

                //             // const label = this.querySelector(`label[for="${input.id}"]`);

                //             if (!available || available == 0) {
                //               input.disabled = true;
                //               // if (label) label.classList.add("disabled-label");
                //             } else {
                //               input.disabled = false;
                //               // if (label) label.classList.remove("disabled-label");
                //             }
                //           })
                //           .catch(err => console.error("SKU inventory error:", err));
                //     });
                  
                // }, 300);
              }
              if(variant.option1.toLowerCase() == 'custom'){

                

                myCustomHandler();
                 /* code for variant additional fields */ 
                document.getElementById('addition_line_property').innerHTML = '';
                /* code for variant additional fields */
              }
              //updateInventory(variant.sku, this.dataset.section);
              document.querySelector(`.var_specification_meta[data-id="${custom_variant_id}"]`)?.classList.remove('hide_var_meta');
              /**/
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Offer-Coupons', ({ classList, textContent }) => classList.contains('hidden') || textContent.trim() === '');

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}
